export const SET_CURRENT_PAGE_COMPONENT = 'currentPageComponent/SET_CURRENT_PAGE_COMPONENT';
